.monaco-aria-container{left:-999em;position:absolute}